<template>
  <div>
    <!-- 背景图 -->
    <div class="top">
      <div class="t-t1">行业案例</div>
      <div class="t-t2box">
        <div class="t-t2">海量企业 通过谛听完美解决需求</div>
      </div>
    </div>

    <!-- 子路由 -->

    <!-- 内容 -->
    <div class="box">
      <!-- 行业选择 -->
      <div class="choice">
        <div class="ch1">行业选择</div>
        <div :class="show == 0 ? 'ch2' : 'ch'" @click="show = 0">房产家具</div>
        <div :class="show == 1 ? 'ch2' : 'ch'" @click="show = 1">旅游服务</div>
        <div :class="show == 2 ? 'ch2' : 'ch'" @click="show = 2">网络服务</div>
        <div :class="show == 3 ? 'ch2' : 'ch'" @click="show = 3">教育培训</div>
        <div :class="show == 4 ? 'ch2' : 'ch'" @click="show = 4">商务服务</div>
        <div :class="show == 5 ? 'ch2' : 'ch'" @click="show = 5">IT/互联网</div>
        <div :class="show == 6 ? 'ch2' : 'ch'" @click="show = 6">汽车</div>
      </div>

      <!-- 每一项 -->
      <div class="item" @click="ToXiangqin">
        <img src="@/image/zhibo/tu1@2x.png" alt="" />

        <div class="text">
          <div class="t1">设备焦点改善案例分析</div>
          <div class="t2">了解设备故障定义及设备故障焦点改善的目的※掌握 设备故障焦点改善开展的活动路径及方法步骤</div>
        </div>
      </div>

      <div class="item">
        <img src="@/image/zhibo/tu2@2x.png" alt="" />

        <div class="text">
          <div class="t1">防错法应用原理及案例分析</div>
          <div class="t2">了解制造过程十大错误※掌握防错三大维度五大思路 十大原理※熟练应用实施七步法降低制造缺陷</div>
        </div>
      </div>

      <div class="item">
        <img src="@/image/zhibo/tu3@2x.png" alt="" />

        <div class="text">
          <div class="t1">创造仅由顾客拉动的价值</div>
          <div class="t2">构建企业精益物流的步骤与方法※如何建立一套准确 的输送拉动系统※配送团队人员配置及成本核算方法</div>
        </div>
      </div>

      <div class="item">
        <img src="@/image/zhibo/tu4@2x.png" alt="" />

        <div class="text">
          <div class="t1">生产设备计划维护活动的推行</div>
          <div class="t2">计划维护活动推行的步骤与路径※ 计划维护系统建立 与设备极限使用</div>
        </div>
      </div>

      <div class="item">
        <img src="@/image/zhibo/tu5@2x.png" alt="" />

        <div class="text">
          <div class="t1">精益项目实施中领导力建设</div>
          <div class="t2">精益推进过程中需要建设领导力的原因※ 将领导力建 设与精益项目推进相结合</div>
        </div>
      </div>

      <div class="item">
        <img src="@/image/zhibo/tu6@2x.png" alt="" />

        <div class="text">
          <div class="t1">制造企业的一线管理如何标准化</div>
          <div class="t2">想了解推行基层管理标准化的意义吗？想知道戴尔是 如何推进基层管理标准化吗？</div>
        </div>
      </div>

      <div class="item">
        <img src="@/image/zhibo/tu7@2x.png" alt="" />

        <div class="text">
          <div class="t1">TPM - 挖掘设备最大价值</div>
          <div class="t2">想了解TPM推行的意义吗？想知道TPM具体有哪些推 行的思路吗？</div>
        </div>
      </div>

      <div class="item">
        <img src="@/image/zhibo/tu8@2x.png" alt="" />

        <div class="text">
          <div class="t1">新工厂精益布局规划</div>
          <div class="t2">想了解精益工厂是如何一步步规划的吗？想知道精益 工厂布局规划的方法论是什么吗？</div>
        </div>
      </div>

      <div class="item">
        <img src="@/image/zhibo/tu9@2x.png" alt="" />

        <div class="text">
          <div class="t1">扬精益 赢未来</div>
          <div class="t2">如何打破实施精益生产“开始容易 坚持很难”的困局？ 如何系统、有效的管理各种精益改善项目？</div>
        </div>
      </div>

      <div class="item">
        <img src="@/image/zhibo/tu10@2x.png" alt="" />

        <div class="text">
          <div class="t1">JIT与拉动式生产</div>
          <div class="t2">理解拉动式生产方式及其好处；※ 了解看板的种类及 实现形式；※ 掌握看板的实施步骤与计算方法。</div>
        </div>
      </div>

      <div class="item">
        <img src="@/image/zhibo/tu11@2x.png" alt="" />

        <div class="text">
          <div class="t1">过程FMEA</div>
          <div class="t2">建立正确的严重度、发生度、探测度评估准则；※ 掌 握过程PFMEA的应用方法。</div>
        </div>
      </div>

      <div class="item">
        <img src="@/image/zhibo/tu12@2x.png" alt="" />

        <div class="text">
          <div class="t1">基层管理者能力提升</div>
          <div class="t2">明确现场管理者的管理职责与角色定位，树立正确的 管理意识与心态观念※了解现场管理的整体框架</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import router from '@/router'
export default {
  name: 'ZhiboIndex',

  data() {
    return {
      show: 0,
    }
  },

  mounted() {},

  methods: {
    ToXiangqin() {
      router.push('/cases')
      this.show = 0
    },
  },
}
</script>

<style lang="scss" scoped>
.box {
  width: 100%;
}
// 行业选择
.choice {
  // margin-left: 150px;
  display: flex;
  margin-bottom: 50px;
  align-items: center;
  .ch1 {
    margin-right: 18px;

    font-size: 20px;
  }
  .ch {
    background-color: #f7f7f7;
    color: #333333;
    font-size: 16px;
    width: 120px;
    height: 36px;
    line-height: 36px;
    text-align: center;
    border-radius: 4px;
    letter-spacing: 1px;
    margin-right: 8px;
  }
  .ch2 {
    background-color: #4581fb;
    color: #fff;
    font-size: 16px;
    width: 120px;
    height: 36px;
    line-height: 36px;
    text-align: center;
    border-radius: 4px;
    letter-spacing: 1px;
    margin-right: 8px;
  }
}

// 行业选择 end--------------
.top {
  z-index: -1;
  position: relative;
  height: 480px;
  background-image: url('@/image/IndustryCases/bj.png');
  background-repeat: no-repeat;

  .t-t1 {
    font-size: 60px;
    color: #000;
    position: absolute;
    z-index: 100;
    top: 28%;
    left: 20%;
  }

  .t-t2box {
    padding-left: 5px;
    color: #666666;
    z-index: 100;
    position: absolute;
    top: 48%;
    left: 20%;
    .t-t2 {
      font-size: 24px;
      margin: 10px 0;
    }
  }
}

.box {
  width: 1300px;
  height: 1730px;
  margin: 50px auto 80px auto;

  padding-left: 150px;

  // justify-content: space-around;

  .item {
    width: 350px;
    height: 400px;

    margin-bottom: -100px;
    float: left;
    margin: 0 30px 30px 0;

    img {
      width: 100%;
    }

    .text {
      padding-top: 15px;
      padding-left: 10px;
      height: 95px;
      box-shadow: 1px 2px 5px 0px #efefef;

      .t1 {
        letter-spacing: 3px;
        margin-bottom: 10px;
      }

      // .ti:hover {
      //   font-size: 30px;
      //   color: #4581fb;
      // }

      .t2 {
        color: #999999;
        font-size: 14px;
      }
    }
  }
  .item:hover {
    transform: translate(0, -8px);
    transition-duration: 0.2s;

    transition-timing-function: linear;
  }
}
</style>
